import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { PageService } from 'src/app/core/page/page.service';
import { selectColorTheme } from 'src/app/store/color-theme/selectors';
import { selectActiveLanguage } from 'src/app/store/language/selectors';
import { AppStateInterface } from 'src/app/store/types';
import { NgOptimizedImage, AsyncPipe } from '@angular/common';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroMinusCircleSolid } from '@ng-icons/heroicons/solid';
import { bootstrapCheckCircleFill } from '@ng-icons/bootstrap-icons';

@Component({
    selector: 'app-employees',
    templateUrl: './employees.component.html',
    styleUrl: './employees.component.scss',
    imports: [
        NgOptimizedImage,
        NgIcon,
        RouterLink,
        AsyncPipe,
        TranslateModule,
    ],
    providers: [provideIcons({ bootstrapCheckCircleFill, heroMinusCircleSolid })]
})
export class EmployeesComponent {
  activeTheme$: Observable<string>;

  constructor(
    private _router: Router,
    private _pageService: PageService,
    private _store: Store<AppStateInterface>,
  ) {
    this.activeTheme$ = this._store.select(selectColorTheme);
  }

  languageDirection: string = 'ltr';

  ngOnInit() {
    this._store.select(selectActiveLanguage).subscribe({
      next: (activeLanguage) => {
        this.languageDirection =
          this._pageService.getLanguageDirection(activeLanguage);
      },
    });
  }
}
